import React, { useState } from 'react';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import HowItWorks from './components/HowItWorks';
import QuestionnairePage from './components/Questionnaire/QuestionnairePage';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [showQuestionnaire, setShowQuestionnaire] = useState(false);

  const handleGetStarted = () => {
    setShowQuestionnaire(true);
  };

  const handleCloseQuestionnaire = () => {
    setShowQuestionnaire(false);
  };

  if (showQuestionnaire) {
    return <QuestionnairePage onClose={handleCloseQuestionnaire} />;
  }

  return (
    <div className="App">
      <Hero onGetStarted={handleGetStarted} />
      <FeaturesSection />
      <HowItWorks onGetStarted={handleGetStarted} />
      <Testimonials />
      <FAQ />
      <Footer />
    </div>
  );
}

export default App;
